export default __webpack_public_path__ + "static/media/humanresource.2a87b844.png";